import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

export const ADMIN_EMAILS = [
  'shaurya.maheshwari2016@gmail.com',
  'savyaraj13@gmail.com'
]

// Role hierarchy:
// viewer      — reader only (not signed in or legacy read-only)
// writer_blog — writer: ALL new signups. Can write & submit to the feed.
// writer_all  — legacy alias, same permissions as writer_blog (keep for DB compat)
// mod         — can moderate content
// admin       — full access
export const ROLES = {
  VIEWER: 'viewer',
  WRITER_BLOG: 'writer_blog',
  WRITER_ALL: 'writer_all',
  MOD: 'mod',
  ADMIN: 'admin'
}

export const ROLE_LABELS = {
  viewer: 'Reader',
  writer_blog: 'Writer',
  writer_all: 'Writer',
  mod: 'Moderator',
  admin: 'Admin'
}

export const ROLE_ORDER = ['viewer', 'writer_blog', 'writer_all', 'mod', 'admin']

export function canWrite(role) {
  return ['writer_blog', 'writer_all', 'mod', 'admin'].includes(role)
}

export function canWriteJournal(role) {
  return ['writer_all', 'mod', 'admin'].includes(role)
}

export function canModerate(role) {
  return ['mod', 'admin'].includes(role)
}

export function isAdmin(role) {
  return role === 'admin'
}
